import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion'; 
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import MainLayout from './components/MainLayout';
import Douae from './components/Douae'
function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <div class="bg-[#020617] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-900/20 via-[#020617] to-[#020617]">
      <div className="absolute inset-0 bg-grid-pattern pointer-events-none"></div>
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-cyan-600/20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute top-3/4 right-1/4 w-[600px] h-[600px] bg-blue-800/10 rounded-full blur-[150px] pointer-events-none"></div>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={
        <div className="App">
     <main className="relative z-10">
        <Navbar/>
        <MainLayout/>
        </main>
      </div>
      }>
      </Route>
        <Route path="/douae/:id" element={<Douae />} />
        <Route path="/douae" element={<Douae />} />
      </Routes>
    </BrowserRouter>
  </div>
  );
}

export default App;